const {
  REACT_APP_AWS_REGION,
  REACT_APP_AWS_USER_POOL_ID,
  REACT_APP_AWS_APP_CLIENT_ID,
  REACT_APP_API_URL,
  REACT_APP_STAGE,
  REACT_APP_SENTRY_DSN,
  REACT_APP_API_URL_V2,
} = process.env

const config = {
  api: {
    endpoint: REACT_APP_API_URL,
    v2endpoint: REACT_APP_API_URL_V2,
  },
  cognito: {
    region: REACT_APP_AWS_REGION,
    userPoolId: REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: REACT_APP_AWS_APP_CLIENT_ID,
  },
  sentry: {
    dsn: REACT_APP_SENTRY_DSN,
    environment: REACT_APP_STAGE,
  },
  stage: REACT_APP_STAGE,
}

export default config
